import { RocketOutlined } from "@ant-design/icons";
import { useMetricPerformanceContext } from "@src/contexts/ab-testing/metric-performance-context";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { Button, Form, Input } from "antd";
import { useTracking } from "react-tracking";

export const ApplyMetric: React.FC<{ targetKey: string }> = ({ targetKey }) => {
    const { trackEvent } = useTracking();
    const { form } = useMetricPerformanceContext();

    const metricTargetModalWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_TARGET_MODEL], form);
    const metricMeasureWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_MEASURE], form);
    const metricMeasureValueWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_MEASURE_VALUE], form);
    const metricMeasureTypeWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_MEASURE_TYPE], form);
    const metricMeasureOptWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_MEASURE_OPTIONS], form);
    const metricSignificanceLevelWatch = Form.useWatch(
        [targetKey, ChartFormFieldsEnum.METRIC_SIGNIFICANCE_LEVEL],
        form,
    );
    const metricFilterWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_FILTER], form);
    const metricBreakdownWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_BREAKDOWN], form);

    const metricAppliedWatch = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_APPLIED], form);
    const metricTabName = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_TAB_NAME], form);

    const mapMetricApplied = {
        [ChartFormFieldsEnum.METRIC_TARGET_MODEL]: metricTargetModalWatch,
        [ChartFormFieldsEnum.METRIC_MEASURE]: metricMeasureWatch,
        [ChartFormFieldsEnum.METRIC_MEASURE_VALUE]: metricMeasureValueWatch,
        [ChartFormFieldsEnum.METRIC_MEASURE_TYPE]: metricMeasureTypeWatch,
        [ChartFormFieldsEnum.METRIC_MEASURE_OPTIONS]: metricMeasureOptWatch,
        [ChartFormFieldsEnum.METRIC_SIGNIFICANCE_LEVEL]: metricSignificanceLevelWatch,
        [ChartFormFieldsEnum.METRIC_FILTER]: metricFilterWatch,
        [ChartFormFieldsEnum.METRIC_BREAKDOWN]: metricBreakdownWatch,
    };

    const isConfigChange = JSON.stringify(mapMetricApplied) !== JSON.stringify(metricAppliedWatch);
    const isDisable = !metricTargetModalWatch || !metricMeasureWatch || JSON.stringify(metricMeasureWatch) === "[]";

    return (
        <div className="flex justify-center">
            <Form.Item name={[targetKey, ChartFormFieldsEnum.METRIC_APPLIED]} hidden>
                <Input />
            </Form.Item>

            <Button
                disabled={!isConfigChange || isDisable}
                onClick={async () => {
                    form.validateFields()
                        .then(() => {
                            form.setFieldValue([targetKey, ChartFormFieldsEnum.METRIC_APPLIED], mapMetricApplied);
                        })
                        .catch((e) => {
                            const isCurrentMetricError = e.errorFields?.some((error: any) => {
                                return error?.name?.includes(targetKey);
                            });
                            if (isCurrentMetricError) return;
                            form.setFieldValue([targetKey, ChartFormFieldsEnum.METRIC_APPLIED], mapMetricApplied);
                        });

                    trackEvent(trackEventPayload.metricItemButtonClick(metricTabName, "apply", mapMetricApplied));
                }}
                icon={<RocketOutlined />}
                type="primary"
            >
                Apply
            </Button>
        </div>
    );
};
